import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import {
  ticketAddUpdate,
  updateCoursePrice,
  fetchAllUnpublishedCourses,
} from "CourseAction";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";

class AddCoursePrice extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {}

  onSubmitForm = (values) => {
    let { session, userCategoryList, settingData, initialValues } = this.props;
    var courseid = initialValues.courseid;
   

    if (values.additionalticketid) {
      if (
        values.additionalticketid != "" &&
        Array.isArray(values.additionalticketid) &&
        values.additionalticketid.length > 0
      ) {
        let addtickets = _.map(values.additionalticketid, (el) => el.value);
        values.additionalticketid = addtickets.join(",");
      } else if (
        values.additionalticketid != "" &&
        !Array.isArray(values.additionalticketid)
      ) {
        values.additionalticketid = values.additionalticketid;
      }
    }

    values.price = values.pricingtype === "free" ? 0 : values.price;

    var attendee = _.filter(userCategoryList.data, (obj) => {
      return obj.type == "attendee";
    });
    var cat = attendee[0].id;
    values.usercategory = cat;
    values.formid = settingData.resource[0].eventformid;


    this.setState({ loading: true });
    this.props.ticketAddUpdate(session, values, (response) => {
     

      if (response.success) {
        values.ticketid = values.ticketid
          ? values.ticketid
          : response.data.resource[0].id;

        this.props.updateCoursePrice(session, values, (res) => {
          this.setState({ loading: false });


          if (res.success) {
            this.props.showSuccess(
              LocaleStrings.course_pricing_form_update_success
            );
            if (this.props.callfrom === "course_list") {
              this.props.finishOperationsCallback();
            }
            this.props.fetchAllUnpublishedCourses(session, courseid);
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
        });
      } else {
        this.setState({ loading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      initialValues,
      editMode,
    } = this.props;


    return (
      <div>
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <AddCoursePriceForm {...this.props} />

          <div className="mt-30">
            <Button
              className="btn btn-custom-blue"
              loading={this.state.loading}
              disabled={pristine || invalid || submitting}
              type="submit"
            >
              {LocaleStrings.button_save}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var initVals = { pricingtype: "paid" };
  if (
    state.allUnpublishedCourseList &&
    state.allUnpublishedCourseList.resource &&
    state.allUnpublishedCourseList.resource.length > 0
  ) {
    initVals = state.allUnpublishedCourseList.resource[0];
    initVals.price =
      state.allUnpublishedCourseList.resource[0].ticketid &&
      state.allUnpublishedCourseList.resource[0].pricingtype == "paid"
        ? state.allUnpublishedCourseList.resource[0].tickets_by_ticketid.price
        : null;
  }

  return {
    session: state.session,
    initialValues: initVals,
    allTicketList: state.allTicketList,
    allUnpublishedCourseList: state.allUnpublishedCourseList,
    userCategoryList: state.userCategoryList,
    settingData: state.SettingData,
  };
}

function validate(values) {


  var errors = {};
  var pricingtype = values["pricingtype"];
  var price = values["price"];

  if (pricingtype == "paid" && !price) {
    errors["price"] = LocaleStrings.course_form_validation_required;
  } else if (pricingtype == "paid" && price < 1) {
    errors["price"] = LocaleStrings.course_form_validation_course_price_invalid;
  }

  return errors;
}

export default connect(mapStateToProps, {
  ticketAddUpdate,
  updateCoursePrice,
  fetchAllUnpublishedCourses,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "CoursePriceForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddCoursePrice)
);

class AddCoursePriceForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { showPriceField: true };

    if (props.initialValues.pricingtype === "free") {
      this.state = { showPriceField: false };
    }
  }

  handlePricingType = (e) => {
    var pricetype = e.target.value;


    if (pricetype == "paid") {
      this.setState({ showPriceField: true });
    } else {
      this.setState({ showPriceField: false });
    }
  };

  renderPriceField = (field) => {
    var { labelposition } = field;
    var { settingData } = this.props;
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    return (
      <div className={divClassName}>
        {field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ""}
            style={{ paddingLeft: 61 }}
          />

          <div className="currency-inside-inputbox">
            {settingData.resource[0].currency}
          </div>

          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  };

  render() {
    let { showPriceField } = this.state;
    let { allTicketList } = this.props;
    let plans = [];

    if (allTicketList) {
      _.map(allTicketList.resource, (item, index) => {
        if (item.status == "enabled") {
          let obj = { name: `${item.ticketname}`, value: item.id.toString() };
          plans.push(obj);
        }
      });
    }

    return (
      <div className="basicform">
        <div className="row form-group">
          <div className="col-sm-12">
            <label className="control-label-top">
              {LocaleStrings.course_pricing_form_label_course_price}
              <span className="label-mandatory">*</span>
            </label>
            <div className="d-flex">
              <Field
                name="pricingtype"
                label={LocaleStrings.course_pricing_form_course_price_option1}
                component={this.renderFieldRadio}
                type="radio"
                value="paid"
                onChange={this.handlePricingType}
              />{" "}
              <Field
                name="pricingtype"
                label={LocaleStrings.course_pricing_form_course_price_option2}
                component={this.renderFieldRadio}
                type="radio"
                value="free"
                onChange={this.handlePricingType}
              />
            </div>
          </div>
        </div>
        {showPriceField === true ? (
          <Field
            name="price"
            label={LocaleStrings.course_pricing_form_label_course_amount}
            placeholder={LocaleStrings.course_pricing_form_ph_course_amount}
            type="number"
            component={this.renderPriceField}
            mandatory="true"
            labelposition={LABEL_POSITION_TOP}
          />
        ) : (
          ""
        )}
        <Field
          name="additionalticketid"
          label={LocaleStrings.course_pricing_form_label_additional_plan}
          placeholder={LocaleStrings.course_pricing_form_ph_additional_plan}
          component={this.renderAutoComplete}
          mandatory="false"
          isMulti={true}
          options={plans}
          labelKey="name"
          valueKey="value"
          value={{}}
        />
        <Field
          name="isfeatured"
          label={LocaleStrings.course_pricing_form_label_isfeatured}
          component={this.renderFieldCheckbox}
          type="checkbox"
        />
      </div>
    );
  }
}
